module.exports = __webpack_public_path__ + "img/square_3.bfb053fa.png";